import { Filter, RotateCcw } from "lucide-react";

import { Card } from "../../../shared/card/card.tsx";
import { Button, Select, type SelectOption } from "../../../ui/index.ts";
import styles from "./employee-view-directory.module.css";

export function EmployeeViewDirectoryFilters({
  employeeId, employeeOptions, loading, onEmployeeChange, onApply, onClear,
}: {
  employeeId: string; employeeOptions: SelectOption[]; loading: boolean;
  onEmployeeChange: (value: string) => void; onApply: () => void; onClear: () => void;
}) {
  return <Card><div className={styles.filterRow}>
    <div className={styles.filterField}><Select label="Employee Name" placeholder={loading ? "Loading..." : "Select Employee Name"} value={employeeId} onChange={onEmployeeChange} options={employeeOptions} searchable isClearable disabled={loading} /></div>
    <div className={styles.filterActions}>
      <Button type="button" variant="accent" startIcon={<Filter size={16} aria-hidden />} onClick={onApply} disabled={loading}>Apply Filter</Button>
      <Button type="button" variant="light-grey" startIcon={<RotateCcw size={16} aria-hidden />} onClick={onClear} disabled={loading}>Clear Filter</Button>
    </div>
  </div></Card>;
}
